import axios, {AxiosInstance} from 'axios';
import {get} from '@/context/context';
import {RequestConfig} from '@/models/RequestConfig';
import {AuthService} from '@/services/AuthService';
import GeneralLoaderService from "@/services/GeneralLoaderService.ts";
import ApiErrors from "@/utils/ApiErrors";
import {defaultServer, Servers, urls} from "@/serverConfig";


export default class API {
    private instance: AxiosInstance;
    private generalLoaderService: GeneralLoaderService = get('generalLoaderService');

    constructor() {
        this.instance = axios.create({
            baseURL: urls[defaultServer],
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }

    private processPromise(promise: Promise<any>, config?: RequestConfig): Promise<any> {
        if (!config || config.loader !== false) {
            const loaderFlag = this.generalLoaderService.showLoader();
            promise.finally(() => {
                this.generalLoaderService.hideLoader(loaderFlag);
            });
        }

        promise.catch((e) => {
            console.log('e', JSON.parse(JSON.stringify(e)));

            const authService: AuthService = get('authService');

            if (e.response && e.response.data) {
                const code = e.response.data.code || e.response.data.error;

                if (code === ApiErrors.USER_UNAUTHORIZED_ERROR
                    ||code === ApiErrors.SESSION_EXPIRED_ERROR
                    ||code === ApiErrors.USER_NOT_LOGGED) {
                    authService.logout();
                }
            }
        });

        return promise;
    }

    public post(url: string, data?: any, config?: RequestConfig) {
        return this.processPromise(this.instance.post(url, data), config);
    }

    public get(url: string, params?: any, config?: RequestConfig) {
        return this.processPromise(this.instance.get(url, { params }), config);
    }

    public delete(url: string, config?: RequestConfig) {
        return this.processPromise(this.instance.delete(url), config);
    }

    public put(url: string, data?: any, config?: RequestConfig) {
        return this.processPromise(this.instance.put(url, data), config);
    }

    // public setCommonHeader(name: string, value: string|number) {
    //     this.instance.defaults.headers.common[name] = value;
    // }

    public changeServer(serverKey: string) {
        this.instance.defaults.baseURL = urls[serverKey];
    }
}
